
import TableList from "@components/templates/tablelist";
import { HttpGetSupplierProduct, HttpSupplierProductUnactive, HttpSupplierProductActive } from "@/service/purchase/purchase";
import { mapState, mapGetters } from "vuex";
import comIndex from '../supplier/update/index'
import comProductIndex from './update/index'
import compERPSKU from '../../products/allproducts/update'
import compSearch from './update/search'
import compbatchImgUpload from "@components/templates/selectupload";
import comExcel from '@components/templates/excelalert'
export default {
    mixins: [TableList],
    components: {
        comIndex,
        compSearch,
        compERPSKU,
        comProductIndex,
        compbatchImgUpload,
        comExcel
    },
    data() { 
        return {
            isMixin: true,
            Tools: {show: true},
            Tabs: {show: true},
            formData:{
                search:{
                    'EQ_status':null,
                }
            },
            Searchs: {
                show: true,
                labelWidth: 100,
            },
            Plugins: {show: true},
            initData:'',
            isShowMain: false
        };
    },
    created () {
        console.log(this.getAllSupplier)
    },
    // async mounted () {
    //     this.productList = await this.getNewDifferentAllProductList.map(item => {
    //         return {
    //             label: item.label,
    //             value: item.value,
    //             flag: item.attach.flag === 3 ? 1 : 0
    //         }
    //     });
    // },
    methods: {
        ajaxRequest: HttpGetSupplierProduct,
        interceptRequest (params) {
            return this.handleParams(params);
        },
        handleParams (params) {
            let search = {
                ...params.search
            }
            console.log(search);
            delete search.undefined;
            if (this.isShowMain) {
                search.EQ_isMasterSupplierId = 1;
            }
            else {
                delete search.EQ_isMasterSupplierId;
            }
            if (search.paymentType) {
                params.paymentType = search.paymentType.join(',');
            }
            else {
                delete params.paymentType;
            }
            delete search.paymentType;
            console.log({
                ...params,
                search: {
                    ...search
                }
            })
            return {
                ...params,
                search: {
                    ...search
                }
            };
        },
        exportQuery () {
            let searchData = this.handleParams(this.formData);
            this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + "/api/v2/SupplierProduct/exportXlsx", {
                ...searchData,
                showmessage:'no'
            }, {
                executor: 'request',
                download: true,
            }).then(res=>{
                this.operate = {
                    title: this.$t('boss.purchase.export_query_conditions',{defaultValue:'查询条件导出'}),
                    show: true,
                    width: 560,
                    component: "comExcel",
                    showFooter: false
                }
            }).catch(err => {
                // this.$VMessage.error(err.message);
            })
        },
        active (params) {
            HttpSupplierProductActive({
                ids: params
            }).then(res => {
                this.$VMessage.success(res.message)
                // this.$forceUpdate()
                this.ajaxRequest()
            }, err => {
                this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
            })
        },
        loseEff (params) {
            HttpSupplierProductUnactive({
                ids: params
            }).then(res => {
                this.$VMessage.success(res.message)
                this.$forceUpdate()
            }, err => {
                this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
            })
        },
        handleOperates(params="", type,batch) {
            if(batch===true){
                params=(params||this.checkedData.join(','))+'';
                if(!params.length) return this.$VMessage.warning(this.$t('boss.purchase.select_data',{defaultValue:'请选择至少一条数据'}));
            }
            switch (type) {
                case "add":
                    this.$router.push({
                        name: 'supplierProductUpdate',
                        params: { type: "add" },
                        // query: { id: params },
                    });
                    break;
                case "edit":
                    window.open(this.$router.resolve({
                        name: 'supplierProductUpdate',
                        params: { type: "edit" },
                        query: { id: params },
                    }).href, '_blank')
                    break;
                case "query":
                    this.operate = {
                        title: this.$t('boss.purchase.view',{defaultValue:'查看'}),
                        show:true,
                        width:1200,
                        component: "comProductIndex",
                        activeid:params,
                        querytype:'query',
                        showFooter:false
                    }
                    break;
                case "querySupplier":
                    this.operate = {
                        title: this.$t('boss.purchase.view',{defaultValue:'查看'}),
                        show:true,
                        width:1200,
                        component: "comIndex",
                        activeid:params,
                        querytype:'query',
                        showFooter:false
                    }
                    break
                case "queryerpsku":
                    this.operate = {
                        title:this.$t("global.common.operation_see",{defaultValue:'查看'}),
                        show:true,
                        width:1200,
                        component: "compERPSKU",
                        activeids:params,
                        querytype:'query'
                    }
                    break;
                case "queryBlank":
                    window.open(this.$router.resolve({
                        name: 'supplierProductUpdate',
                        params: { type: "query" },
                        query: { id: params },
                    }).href, '_blank')
                    break;
                case 'loseEff':
                    // this.loseEff(params)
                    this.operate = {
                        show: true,
                        alert: "error",
                        title: this.$t('boss.purchase.lose_efficacy',{defaultValue:'失效'}),
                        width: 460,
                        params:{ids:params},
                        ajaxRequest:HttpSupplierProductUnactive
                    };
                    break
                case 'moreImport':
                    // 点击导入按钮
                    this.operate = {
                        show: true,
                        title: this.$t('boss.purchase.batch_import',{defaultValue:'批量导入'}),
                        width:460,
                        showFooter: false,
                        data: {},
                        action: process.env.VUE_APP_APIURL_BOSS + "/api/v2/SupplierProduct/importExcel",
                        name: "excelFile",
                        component: "compUpload",
                        download:()=>{
                            this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + '/api/v2/SupplierProduct/downItemExcel', {}, 'download')
                        }
                    }
                    break
                case 'exportQuery':
                    this.exportQuery(params)
                    break
                case 'active':
                    this.operate = {
                        show: true,
                        alert: "error",
                        title: this.$t('boss.purchase.enabled',{defaultValue:'启用'}),
                        width: 460,
                        params:{ids:params},
                        ajaxRequest:HttpSupplierProductActive
                    };
                    break
                case 'batchimg':
                    
                    this.operate = {
                        show: true,
                        title: this.$t('boss.purchase.import_data',{defaultValue:'导入数据'}),
                        width: 530,
                        showFooter: false,
                        name: "files",
                        component: "compbatchImgUpload",
                        showdownload:1,
                        actionurl:process.env.VUE_APP_APIURL_BOSS+'/api/v2/SupplierProduct/batchUploadPic',
                        params:{isMaster:1},
                        warningtitle:this.$t('boss.purchase.main01_jpg',{defaultValue:'图片以ERP SKU为前缀命名，中间加@，后面写产品图片的描述比如A001@主01.jpg'}),
                        formdata: [
                            {
                                span:24,
                                label: this.$t('boss.purchase.is_main_image',{defaultValue:'是否主图'}),
                                key: 'isMaster',
                                tag: 'vRadio',
                                props: {
                                    strict: false,
                                },
                                options: [{
                                    trueValue: 1,
                                    label: this.$t('boss.purchase.correct',{defaultValue:'是'})
                                }, {
                                    trueValue: 0,
                                    label: this.$t('boss.purchase.deny',{defaultValue:'否'})
                                }]
                            },
                        ],
                        
                    };
                    break;
                    
                // 批量修改主供应商
                case 'batchChangeSupplier':
                    this.operate = {
                        show: true,
                        title: this.$t('boss.purchase.batch_modification',{defaultValue:'批量修改主供应商'}),
                        width: 460,
                        showFooter: false,
                        action: process.env.VUE_APP_APIURL_BOSS + '/api/v2/SupplierProduct/importMasterSupplierExcel',
                        name: 'excelFile',
                        component: "compUpload",
                        download: () => {
                            this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + '/api/v2/SupplierProduct/downMasterSupplierExcel', {}, 'download')
                        }
                    };
                    break;
            }
        },
        getOperateNodeMap(row){
            const { id } = row
            return [{
                label:this.$t('boss.purchase.view',{defaultValue:'查看'}),
                show: true,
                params:id,
                operate:'query'
            },{
                label:this.$t('boss.purchase.edit',{defaultValue:'编辑'}),
                show: row.status === 1 ? true : false,
                params:id,
                operate:'edit'
                // to: {
                //     name: 'supplierProductUpdate',
                //     params: { type: 'edit' },
                //     query: { id },
                // },
            }, {
                label: this.$t('boss.purchase.enabled',{defaultValue:'启用'}),
                show: row.status === 0 ? true : false,
                params: id,
                operate: 'active'
            }, {
                label:this.$t('boss.purchase.lose_efficacy',{defaultValue:'失效'}),
                show: row.status === 1 ? true : false,
                params:id,
                operate:'loseEff'
            }]
        },
    },
    computed: {
        ...mapGetters('diction',['getNewProductList','getAllCurrency','getAllSupplier', 'getNewDifferentAllProductList']),
        productList(){
            return this.getNewDifferentAllProductList.map(item => {
                const bool = item.attach.flag === 3 ? 1 : 0
                return {
                    label: bool==1 ? `<span class='color-error'>${item.label}` + this.$t('boss.purchase.closed_a',{defaultValue:'(已关闭)'}) + `</span>` : `${item.label}`,
                    value: item.value,
                }
            });
            
        },
        getBind() {
            return {
                on: {
                    'on-query': this.queryChange
                }
            }
        },
        TabsData(){
            return [
                {
                    name: this.$t('boss.purchase.all',{defaultValue:'所有'}),
                    key:'EQ_status',
                    val: null
                }, {
                    name: this.$t('boss.purchase.effective',{defaultValue:'有效'}),
                    key:'EQ_status',
                    val: '1'
                }, {
                    name: this.$t('boss.purchase.lose_efficacy',{defaultValue:'失效'}),
                    key:'EQ_status',
                    val: '0'
                }
            ]
        },
        ToolsData(){
            return [
                {
                    name: this.$t('boss.purchase.add',{defaultValue:'新增'}),
                    operate: "add",
                    theme: "primary",
                },
                {
                    name: this.$t('boss.purchase.export_query_conditions',{defaultValue:'查询条件导出'}),
                    operate: 'exportQuery',
                    theme: 'primary'
                },
                {
                    name: this.$t('boss.purchase.batch_import',{defaultValue:'批量导入'}),
                    operate: 'moreImport',
                    more:true,
                },
                {
                    name: this.$t('boss.purchase.batch_invalidation',{defaultValue:'批量失效'}),
                    // operate: "close",
                    operate: 'loseEff',
                    more:true,
                    batch:true
                },
                {
                    name: this.$t('boss.purchase.batch_activation',{defaultValue:'批量启用'}),
                    operate: 'active',
                    more: true,
                    batch: true
                },
                {
                    name: this.$t('boss.purchase.batch_import_images',{defaultValue:'批量导入图片'}),
                    operate: 'batchimg',
                    more: true,
                },
                {
                    name: this.$t('boss.purchase.batch_modification',{defaultValue:'批量修改主供应商'}),
                    operate: 'batchChangeSupplier',
                    more: true
                }
            ]
        },
        SearchsData() {
            let widthStyle = 'width: 250px'
            return  [
                {
                    label: "ERP SKU",
                    // labelWidth: 110,
                    tag: 'vInput',
                    key: 'EQ_erpsku',
                    show:true
                },
                {
                    label: this.$t('boss.purchase.supplier_name',{defaultValue:'供应商名称'}),
                    // labelWidth: 110,
                    tag: 'Select',
                    class:'minSelect',
                    props: {
                        filterable: true,
                        multiple: true,
                    },
                    key: 'IN_supplierId',
                    options: this.getAllSupplier.map(item => {
                        return {
                            value: item.value,
                            label: `${item.label}(${item.attach.code})`
                        }
                    }),
                    show: true,
                    // style: widthStyle
                },
                // {
                //     label: "币种",
                //     // labelWidth: 110,
                //     tag: 'vSelect',
                //     key: 'IN_currency',
                //     show: true,
                //     options: this.getAllCurrency,
                //     props: {
                //         multiple: true
                //     },
                // },
                {
                    label: this.$t('boss.purchase.factory_product_code',{defaultValue:'工厂产品编码'}),
                    tag: 'vInput',
                    key: 'EQ_factoryCode',
                    style: widthStyle
                },
                {
                    label: this.$t('boss.purchase.project',{defaultValue:'项目'}),
                    // labelWidth: 110,
                    tag: 'Select',
                    options: this.productList,
                    key: 'IN_lineId',
                    hideSearchTip: true,
                    props: {
                        multiple: true,
                        filterable: true
                    },
                    style: widthStyle,
                },
                // {
                //     label: '采购单价',
                //     key: "GE_price",
                //     tag: "vInputNumber",
                //     props: {
                //         min: 0
                //     },
                //     combineKey: 'price',
                //     style: 'width: 115px;'
                // },
                // {
                //     label: '~',
                //     key: "LE_price",
				// 	tag: "vInputNumber",
                //     props: {
                //         min: 0
                //     },
                //     formItem:{
                //         style: "margin-left: -80px"
                //     },
                //     combineKey: 'price',
                //     style: 'width: 115px;'
                // },
                {
                    label: this.$t('boss.purchase.product_description',{defaultValue:'产品描述'}),
                    tag: 'vInput',
                    key: 'CN_productDescription',
                    style: widthStyle
                },
                {
                    label: this.$t('boss.purchase.port_delivery',{defaultValue:'交货港'}),
                    tag: 'vInput',
                    key: 'CN_deliveryPort',
                    style: widthStyle
                },
                {
                    label: this.$t('boss.purchase.production_cycle',{defaultValue:'生产周期'}),
                    key: "GE_cycle",
                    tag: "vInputNumber",
                    props: {
                        min: 0
                    },
                    combineKey: 'cycle',
                    style: 'width: 115px;'
                },
                {
                    label: '~',
                    key: "LE_cycle",
					tag: "vInputNumber",
                    props: {
                        min: 0
                    },
                    formItem:{
                        style: "margin-left: -80px"
                    },
                    combineKey: 'cycle',
                    style: 'width: 115px;'
                },
                {
                    label: this.$t('boss.purchase.minimum_order_quantity',{defaultValue:'最小起订量'}),
                    key: "GE_minOrderQuantity",
                    tag: "vInputNumber",
                    props: {
                        min: 0
                    },
                    combineKey: 'minOrderQuantity',
                    style: 'width: 115px;'
                },
                {
                    label: '~',
                    key: "LE_minOrderQuantity",
					tag: "vInputNumber",
                    props: {
                        min: 0
                    },
                    formItem:{
                        style: "margin-left: -80px"
                    },
                    combineKey: 'minOrderQuantity',
                    style: 'width: 115px;'
                },
                {
                    label: this.$t('boss.purchase.customs_declaration_product_name',{defaultValue:'报关品名'}),
                    tag: 'vInput',
                    key: 'CN_htsname',
                    style: widthStyle
                },
                {
                    label: this.$t('boss.purchase.packing_quantity',{defaultValue:'装箱入数'}),
                    tag: 'vInputNumber',
                    key: 'GE_cartonPackedQty',
                    props: {
                        min: 0
                    },
                    combineKey: 'cartonPackedQty',
                    style: 'width: 115px;'
                },
                {
                    label: '~',
                    key: "LE_cartonPackedQty",
					tag: "vInputNumber",
                    props: {
                        min: 0
                    },
                    formItem:{
                        style: "margin-left: -80px"
                    },
                    combineKey: 'cartonPackedQty',
                    style: 'width: 115px;'
                },
                {
                    label: this.$t('boss.purchase.bidder',{defaultValue:'报价人'}),
                    tag: 'vInput',
                    key: 'CN_inquirer',
                    style: widthStyle
                },
                {
                    label: this.$t('boss.purchase.created_at',{defaultValue:'创建时间'}),
                    tag: 'vDatepicker',
                    key: 'BT_createdAt',
                    props:{
                        options:this.options,
                        format:'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm:false,
                    },
                    style: widthStyle
                },
                {
                    label: this.$t('boss.purchase.procurement_model',{defaultValue:'采购模式'}),
                    tag: "vSelect",
                    key: 'paymentType',
                    props: {
                        multiple: true
                    },
                    options: [
                        {
                            label: this.$t('boss.purchase.nil',{defaultValue:'无'}),
                            value: "undefined"
                        },
                        {
                            label: this.$t('boss.purchase.self_procurement',{defaultValue:'自采'}),
                            value: "payment"
                        },
                        {
                            label: this.$t('boss.purchase.agency_operations',{defaultValue:'代运营'}),
                            value: "unpayment"
                        },
                        {
                            label: this.$t('boss.purchase.financial_procurement_agency',{defaultValue:'金融代采'}),
                            value: "fk"
                        }
                    ],
                    style: widthStyle
                },
                {
                    label: this.$t('boss.purchase.procurement_contract_a',{defaultValue:'是否有预采合同'}),
                    key: "EQ_prePurchaseType",
                    tag: "vSelect",
                    options: [
                        {
                            label: this.$t('boss.purchase.correct',{defaultValue:'是'}),
                            value: 1
                        },
                        {
                            label: this.$t('boss.purchase.deny',{defaultValue:'否'}),
                            value: 0
                        }
                    ],
                    style: widthStyle
                },
                {
                    label: this.$t('boss.purchase.main_supplier',{defaultValue:'只展示主供应商'}),
                    tag: "Checkbox",
                    on: {
                        'on-change': (val) => {
                            this.isShowMain = val;
                        }  
                    },
                    style: widthStyle
                },
            ]
        },
        columns() {
            return  [
            {
                show:false,
                type: 'selection',
                width: 40,
                align: 'center',
                formName: 'id'
            },{
                title: this.$t('boss.purchase.operate',{defaultValue:'操作'}),
                width: 70,
                render:this.getOperateNodes,
            },{
                title: this.$t('boss.purchase.host_graph',{defaultValue:'主图'}),
                width:130,
                render:(h,{row})=>{
                    let jsonone = row.pictures.filter(json=>{
                        return json.isMaster === 1
                    })[0] || {}
                    return <div>
                         <img v-show={jsonone.pictureUrl} src={jsonone.pictureUrl} style="max-width:70px;max-height:70px;margin-left:20px"></img>
                    </div>
                }
            } ,
            {
                title: this.$t('boss.purchase.supplier_name',{defaultValue:'供应商名称'}),
                sortable: true,
                // width: 120,
                render:(h,{row})=>{
                    let supplierItem = this.getAllSupplier.filter(item => {
                        return item.value == row.supplierId
                    })[0] || {}
                    let isMainSupplier = row.isMasterSupplierId === 1;
                    // console.log(isMainSupplier);
                    // console.log(row)
                    
                    // console.log(jsonone)
                    return (
                    <div>
                        <div v-show={isMainSupplier}
                                style={`
                                float: left;
                                border: 2px solid rgb(237, 64, 20);
                                background-color: #ed4014;
                                border-radius: 100%;
                                padding: 0 2px;
                                line-height: 15px;
                                margin-right: 10px;
                                color: #fff;
                                `}
                            >{this.$t("boss.purchase.host",{defaultValue:"主"})}</div>
                        <div style="float:left">
                            <a onClick={this.handleOperates.bind(this, row.supplierId, 'querySupplier')}>{supplierItem.label}</a>
                            <a onClick={this.handleOperates.bind(this, row.supplierId, 'queryBlank')}><vIcon class="margin-left-10 font-14" type="ios-browsers-outline" /></a>
                            <div>{supplierItem.attach ? supplierItem.attach.nameEn : ''}</div>
                            <div>{supplierItem.attach ? supplierItem.attach.code : ''}</div>
                        </div>
                       
                        
                    </div>
                    )
                    // return <div>{supplierItem.label}</div>
                }
            },
            {
                title: 'ERP SKU',
                width: 120,
                render:(h,{row})=>{
                    return (
                    <div>
                        <div>
                            <a onClick={this.handleOperates.bind(this, row.id, 'query')}>{row.erpsku}</a>
                        </div>
                    </div>
                    )
                    
                }
            },
            // {
            //     title: '币种',
            //     width: 60 ,
            //     align: 'center',
            //     render:(h, { row })=>{
            //         return <div>{row.currency}</div>
            //     }
            // },
            {
                title: this.$t("boss.purchase.purchase_unit_price",{defaultValue:"采购单价"}),
                width: 100,
                render:(h,{row})=>{
                    let keyArr = {
                        usdPrice: 'USD',
                        cnyPrice: 'CNY',
                        eurPrice: 'EUR',
                        jpyPrice: 'JPY',
                        cadPrice: 'CAD',
                        gbpPrice: 'GBP',
                        mxnPrice: 'MXN',
                        audPrice: 'AUD'
                    }
                    let result = []
                    Object.keys(row).map(item => {
                        let keyName = '',
                            value = ''
                        if (keyArr[item] === 0 || keyArr[item]) {
                            keyName = keyArr[item]
                            value = row[item]
                            if (row[item] || row[item] === 0) {
                                result.push(<div>{keyName}:<span class="font-weight">{value}</span></div>)
                            }
                        }
                    })
                    return (
                        <div>
                            {result}
                        </div>
                    )
                }
            },
            // {
            //     title: '生产周期',
            //     width: 80,
            //     render:(h,{row})=>{
            //         return <div>{row.cycle}</div>
            //     }
            // },
            {
                title: this.$t("boss.purchase.basic_information_supplier_products",{defaultValue:"供应商产品基本信息"}),
                // width: 240,
                render: (h, {row}) => {
                    // let result = []
                    let productItem = this.getNewDifferentAllProductList.filter(item => {
                        return item.value === row.lineId
                    })[0] || {}
                    let needShow = true
                    if (!row.length && !row.width && !row.height) {
                        needShow = false
                    }
                    return (
                    <div>
                        <div>{this.$t("boss.purchase.project",{defaultValue:"项目"})}:<span class="font-weight">{productItem.label}</span></div>
                        <div>{this.$t("boss.purchase.factory_product_code",{defaultValue:"工厂产品编码"})}:<a class="font-weight" onClick={this.handleOperates.bind(this, row.id, 'query')}>{row.factoryCode}</a></div>
                        <div>{this.$t("boss.purchase.production_cycle",{defaultValue:"生产周期"})}:<span class="font-weight">{row.cycle}</span></div>
                        <div>{this.$t("boss.purchase.minimum_order_quantity",{defaultValue:"最小起订量"})}:<span class="font-weight">{row.minOrderQuantity}</span></div>
                        <div>{this.$t("boss.purchase.individual_packaging_size",{defaultValue:"单品外包装尺寸（inch）"})}:
                            <span class="font-weight">
                                {this.handleUnit(row.length, 'cm', 'inch', 2)}
                                {needShow ? '*' : ''}
                                {this.handleUnit(row.width, 'cm', 'inch', 2)}
                                {needShow ? '*' : ''}
                                {this.handleUnit(row.height, 'cm', 'inch', 2)}
                            </span>
                        </div>
                        <div>{this.$t("boss.purchase.project",{defaultValue:"产品毛重（lb）"})}:<span class="font-weight">{this.handleUnit(row.weight, 'g', 'lb', 2)}</span></div>
                        <div>{this.$t("boss.purchase.product_description",{defaultValue:"产品描述"})}:<span class="font-weight">{row.productDescription}</span></div>
                    </div>
                    )
                }
            },
            {
                title: this.$t("boss.purchase.other_information_supplier",{defaultValue:"供应商产品其他信息"}),
                // width: 240,
                render: (h, {row}) => {
                    let needShow = true
                    if (!row.cartonLength && !row.cartonWidth && !row.cartonHeight) {
                        needShow = false
                    }
                    return (
                        <div>
                            <div>{this.$t("boss.purchase.customs_decl aration_product_name",{defaultValue:"报关品名"})}:<span class="font-weight">{row.htsname}</span></div>
                            <div>{this.$t("boss.purchase.packing_quantity",{defaultValue:"装箱入数"})}:<span class="font-weight">{row.cartonPackedQty}</span></div>
                            <div>{this.$t("boss.purchase.port_delivery",{defaultValue:"交货港"})}:<span class="font-weight">{row.deliveryPort}</span></div>
                            <div>{this.$t("boss.purchase.outer_box_inches",{defaultValue:"交货港外箱长宽高（inch）"})}:
                                <span class="font-weight">
                                    {this.handleUnit(row.cartonLength, 'cm', 'inch', 2)}
                                    {needShow ? '*' : ''}
                                    {this.handleUnit(row.cartonWidth, 'cm', 'inch', 2)}
                                    {needShow ? '*' : ''}
                                    {this.handleUnit(row.cartonHeight, 'cm', 'inch', 2)}
                                </span>
                            </div>
                            <div>{this.$t("boss.purchase.outer_box_lb",{defaultValue:"外箱毛重（lb）"})}:<span class="font-weight">{this.handleUnit(row.cartonWeight, 'g', 'lb', 2)}</span></div>
                        </div>
                    )
                }
            },
            // {
            //     title: '工厂编码',
            //     render: (h, {row}) => {
            //         return <div><a onClick={this.handleOperates.bind(this, row.id, 'query')}>{row.factoryCode}</a>
            //         </div>
            //     }
            // },
            {
                title:this.$t("boss.purchase.state",{defaultValue:"状态"}),
                width: 80,
                render: (h, {row}) => {
                    let str = this.$t("boss.purchase.effective",{defaultValue:"有效"}),
                        className = 'tag-blue tagSize',
                        style = ''
                    if (row.status === 0) {
                        str = this.$t("boss.purchase.lose_efficacy",{defaultValue:"失效"})
                        className = 'tag-blue tagSize'
                        style = 'color: #bbbec4; border-color: #bbbec4;'
                    }
                    // return <div style={style}>{str}</div>
                    return <span class={className} style={style}>{str}</span>
                }
            },
            // {
            //     title: '备注',
            //     width: 100,
            //     render:(h,{row})=>{
            //         return <div>{row.remark}</div>
            //     }
            // },
            {
                title: this.$t("boss.purchase.update_time",{defaultValue:"更新时间"}),
                key:'updatedAt',
                width: 130
            }];
        },

    }

};
